import { render, staticRenderFns } from "./RowContentWrapper.vue?vue&type=template&id=2b179348&scoped=true"
import script from "./RowContentWrapper.vue?vue&type=script&lang=js"
export * from "./RowContentWrapper.vue?vue&type=script&lang=js"
import style0 from "./RowContentWrapper.vue?vue&type=style&index=0&id=2b179348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b179348",
  null
  
)

export default component.exports